export enum DrawerTypes {
    FIXED_DRAWER = "fixed_drawer",
    COLLAPSED_DRAWER = "collapsible",
    MINI_DRAWER = "mini_drawer"
};

export default DrawerTypes;